import isPlainObject from 'lodash/isPlainObject';

export const isBoolean = (bool, previousValue) => (typeof bool === 'boolean' ? bool : previousValue);
export const isString = (stg, previousValue) => (typeof stg === 'string' ? stg : previousValue);
export const isObject = (obj, previousValue) => (isPlainObject(obj) ? obj : previousValue);
export const isArray = (arr, previousValue) => (Array.isArray(arr) ? arr : previousValue);
export const isNumber = (num, previousValue) => (typeof num === 'number' ? num : previousValue);
